<div class="dialog-container">
  <div class="header">
    <img class="photo" [src]="getPractitionerPhoto()" alt="Foto do Especialista" />
    <div class="title-section">
      <h2>{{ practitioner.name }}</h2>
      <p class="subtitle">Especialista</p>
    </div>
  </div>

  <div class="section">
    <h3>Especialidades</h3>
    <ul>
      <li *ngFor="let specialty of practitionerRole.specialty">{{ specialty.value }} - CRM {{ specialty.crm }} ({{ specialty.uf }})</li>
    </ul>
  </div>

  <div class="section" *ngIf="practitioner.qualifications.length > 0">
    <h3>Qualificações</h3>
    <ul>
      <li *ngFor="let qualification of practitioner.qualifications">
        {{ qualification.name }} - {{ qualification.level }} ({{ qualification.instituition }} - {{ formatDate(qualification.dateConclusion) }})
      </li>
    </ul>
  </div>

  <div class="section" *ngIf="practitioner.certificates.length > 0">
    <h3>Formações</h3>
    <ul>
      <li *ngFor="let certificate of practitioner.certificates">{{ certificate.name }} - {{ certificate.instituition }}</li>
    </ul>
  </div>

  <div class="section">
    <h3>Idiomas</h3>
    <ul>
      <li *ngFor="let idiome of practitioner.communication">{{ idiome.language }} (Nível: {{ idiome.proficiency }})</li>
    </ul>
  </div>

  <div class="section" *ngIf="practitioner.accessibilities?.length > 0">
    <h3>Acessibilidade</h3>
    <ul>
      <li *ngFor="let accessibility of practitioner.accessibilities[0]?.name">
        {{ accessibility | titlecase }}
      </li>
    </ul>
  </div>

  <div class="footer-actions">
    <button mat-button color="primary" (click)="onClose()">Fechar</button>
  </div>
</div>
